/* ADEZZ family 1389; exact source labels, local facet mapping. No prices or licensed RAL colour table. */
(function (root) {
  const colors = [
  {
    "key": "RAL-7021",
    "code": "RAL 7021",
    "supplierCode": "7021",
    "label": "RAL 7021 · Schwarzgrau",
    "raw": "RAL 7021 (Schwarzgrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#23282B"
  },
  {
    "key": "RAL-7016",
    "code": "RAL 7016",
    "supplierCode": "7016",
    "label": "RAL 7016 · Anthrazitgrau",
    "raw": "RAL 7016 (Anthrazitgrau) - Matt",
    "group": "Anthrazit",
    "system": "RAL",
    "hex": "#293133"
  },
  {
    "key": "RAL-9005",
    "code": "RAL 9005",
    "supplierCode": "9005",
    "label": "RAL 9005 · Tiefschwarz",
    "raw": "RAL 9005 (Tiefschwarz) - Matt",
    "group": "Schwarz",
    "system": "RAL",
    "hex": "#0A0A0A"
  },
  {
    "key": "RAL-9016",
    "code": "RAL 9016",
    "supplierCode": "9016",
    "label": "RAL 9016 · Verkehrsweiß",
    "raw": "RAL 9016 (Verkehrsweiß) - Matt",
    "group": "Weiß",
    "system": "RAL",
    "hex": "#F6F6F6"
  },
  {
    "key": "RAL-1015",
    "code": "RAL 1015",
    "supplierCode": "1015",
    "label": "RAL 1015 · Hellelfenbein",
    "raw": "RAL 1015 (Hellelfenbein) - Matt",
    "group": "Beige",
    "system": "RAL",
    "hex": "#E6D1B5"
  },
  {
    "key": "RAL-6013",
    "code": "RAL 6013",
    "supplierCode": "6013",
    "label": "RAL 6013 · Schilfgrün",
    "raw": "RAL 6013 (Schilfgrün) - Matt",
    "group": "Grün",
    "system": "RAL",
    "hex": "#6C7156"
  },
  {
    "key": "RAL-7006",
    "code": "RAL 7006",
    "supplierCode": "7006",
    "label": "RAL 7006 · Beigegrau",
    "raw": "RAL 7006 (Beigegrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#6D6552"
  },
  {
    "key": "RAL-7031",
    "code": "RAL 7031",
    "supplierCode": "7031",
    "label": "RAL 7031 · Blaugrau",
    "raw": "RAL 7031 (Blaugrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#474B4E"
  },
  {
    "key": "RAL-7022",
    "code": "RAL 7022",
    "supplierCode": "7022",
    "label": "RAL 7022 · Umbragrau",
    "raw": "RAL 7022 (Umbragrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#4C4A44"
  },
  {
    "key": "RAL-7044",
    "code": "RAL 7044",
    "supplierCode": "7044",
    "label": "RAL 7044 · Seidengrau",
    "raw": "RAL 7044 (Seidengrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#CAC4B0"
  },
  {
    "key": "RAL-8004",
    "code": "RAL 8004",
    "supplierCode": "8004",
    "label": "RAL 8004 · Kupferbraun",
    "raw": "RAL 8004 (Kupferbraun) - Matt",
    "group": "Braun",
    "system": "RAL",
    "hex": "#8E402A"
  },
  {
    "key": "RAL-8019",
    "code": "RAL 8019",
    "supplierCode": "8019",
    "label": "RAL 8019 · Graubraun",
    "raw": "RAL 8019 (Graubraun) - Matt",
    "group": "Braun",
    "system": "RAL",
    "hex": "#403A3A"
  },
  {
    "key": "RAL-8024",
    "code": "RAL 8024",
    "supplierCode": "8024",
    "label": "RAL 8024 · Beigebraun",
    "raw": "RAL 8024 (Beigebraun) - Matt",
    "group": "Braun",
    "system": "RAL",
    "hex": "#79553D"
  },
  {
    "key": "RAL-9002",
    "code": "RAL 9002",
    "supplierCode": "9002",
    "label": "RAL 9002 · Grauweiß",
    "raw": "RAL 9002 (Grauweiß) - Matt",
    "group": "Weiß",
    "system": "RAL",
    "hex": "#D8D6CB"
  },
  {
    "key": "RAL-1014",
    "code": "RAL 1014",
    "supplierCode": "1014",
    "label": "RAL 1014 · Elfenbein",
    "raw": "RAL 1014 (Elfenbein) - Matt",
    "group": "Beige",
    "system": "RAL",
    "hex": "#DDC49A"
  },
  {
    "key": "RAL-1019",
    "code": "RAL 1019",
    "supplierCode": "1019",
    "label": "RAL 1019 · Graubeige",
    "raw": "RAL 1019 (Graubeige) - Matt",
    "group": "Beige",
    "system": "RAL",
    "hex": "#9E9764"
  },
  {
    "key": "RAL-3007",
    "code": "RAL 3007",
    "supplierCode": "3007",
    "label": "RAL 3007 · Schwarzrot",
    "raw": "RAL 3007 (Schwarzrot) - Matt",
    "group": "Rot",
    "system": "RAL",
    "hex": "#412227"
  },
  {
    "key": "RAL-3015",
    "code": "RAL 3015",
    "supplierCode": "3015",
    "label": "RAL 3015 · Hellrosa",
    "raw": "RAL 3015 (Hellrosa) - Matt",
    "group": "Rot",
    "system": "RAL",
    "hex": "#EA899A"
  },
  {
    "key": "RAL-4004",
    "code": "RAL 4004",
    "supplierCode": "4004",
    "label": "RAL 4004 · Bordeauxviolett",
    "raw": "RAL 4004 (Bordeauxviolett) - Matt",
    "group": "Violett",
    "system": "RAL",
    "hex": "#641C34"
  },
  {
    "key": "RAL-5002",
    "code": "RAL 5002",
    "supplierCode": "5002",
    "label": "RAL 5002 · Ultramarinblau",
    "raw": "RAL 5002 (Ultramarinblau) - Matt",
    "group": "Blau",
    "system": "RAL",
    "hex": "#20214F"
  },
  {
    "key": "RAL-6004",
    "code": "RAL 6004",
    "supplierCode": "6004",
    "label": "RAL 6004 · Blaugrün",
    "raw": "RAL 6004 (Blaugrün) - Matt",
    "group": "Grün",
    "system": "RAL",
    "hex": "#1F3A3D"
  },
  {
    "key": "RAL-6021",
    "code": "RAL 6021",
    "supplierCode": "6021",
    "label": "RAL 6021 · Blassgrün",
    "raw": "RAL 6021 (Blassgrün) - Matt",
    "group": "Grün",
    "system": "RAL",
    "hex": "#89AC76"
  },
  {
    "key": "RAL-7030",
    "code": "RAL 7030",
    "supplierCode": "7030",
    "label": "RAL 7030 · Steingrau",
    "raw": "RAL 7030 (Steingrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#8B8C7A"
  },
  {
    "key": "RAL-7035",
    "code": "RAL 7035",
    "supplierCode": "7035",
    "label": "RAL 7035 · Lichtgrau",
    "raw": "RAL 7035 (Lichtgrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#D7D7D7"
  },
  {
    "key": "RAL-7039",
    "code": "RAL 7039",
    "supplierCode": "7039",
    "label": "RAL 7039 · Quarzgrau",
    "raw": "RAL 7039 (Quarzgrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#6C6960"
  },
  {
    "key": "RAL-8022",
    "code": "RAL 8022",
    "supplierCode": "8022",
    "label": "RAL 8022 · Schwarzbraun",
    "raw": "RAL 8022 (Schwarzbraun) - Matt",
    "group": "Braun",
    "system": "RAL",
    "hex": "#212121"
  },
  {
    "key": "RAL-9001",
    "code": "RAL 9001",
    "supplierCode": "9001",
    "label": "RAL 9001 · Cremeweiß",
    "raw": "RAL 9001 (Cremeweiß) - Matt",
    "group": "Weiß",
    "system": "RAL",
    "hex": "#FDF4E3"
  },
  {
    "key": "RAL-1000",
    "code": "RAL 1000",
    "supplierCode": "1000",
    "label": "RAL 1000 · Grünbeige",
    "raw": "RAL 1000 (Grünbeige) - Matt",
    "group": "Beige",
    "system": "RAL",
    "hex": "#BEBD7F"
  },
  {
    "key": "RAL-1001",
    "code": "RAL 1001",
    "supplierCode": "1001",
    "label": "RAL 1001 · Beige",
    "raw": "RAL 1001 (Beige) - Matt",
    "group": "Beige",
    "system": "RAL",
    "hex": "#C2B078"
  },
  {
    "key": "RAL-1002",
    "code": "RAL 1002",
    "supplierCode": "1002",
    "label": "RAL 1002 · Sandgelb",
    "raw": "RAL 1002 (Sandgelb) - Matt",
    "group": "Gelb",
    "system": "RAL",
    "hex": "#C6A664"
  },
  {
    "key": "RAL-1003",
    "code": "RAL 1003",
    "supplierCode": "1003",
    "label": "RAL 1003 · Signalgelb",
    "raw": "RAL 1003 (Signalgelb) - Matt",
    "group": "Gelb",
    "system": "RAL",
    "hex": "#E5BE01"
  },
  {
    "key": "RAL-1004",
    "code": "RAL 1004",
    "supplierCode": "1004",
    "label": "RAL 1004 · Goldgelb",
    "raw": "RAL 1004 (Goldgelb) - Matt",
    "group": "Gelb",
    "system": "RAL",
    "hex": "#CDA434"
  },
  {
    "key": "RAL-1006",
    "code": "RAL 1006",
    "supplierCode": "1006",
    "label": "RAL 1006 · Maisgelb",
    "raw": "RAL 1006 (Maisgelb) - Matt",
    "group": "Gelb",
    "system": "RAL",
    "hex": "#E4A010"
  },
  {
    "key": "RAL-1007",
    "code": "RAL 1007",
    "supplierCode": "1007",
    "label": "RAL 1007 · Narzissengelb",
    "raw": "RAL 1007 (Narzissengelb) - Matt",
    "group": "Gelb",
    "system": "RAL",
    "hex": "#DC9D00"
  },
  {
    "key": "RAL-1011",
    "code": "RAL 1011",
    "supplierCode": "1011",
    "label": "RAL 1011 · Braunbeige",
    "raw": "RAL 1011 (Braunbeige) - Matt",
    "group": "Beige",
    "system": "RAL",
    "hex": "#8A6642"
  },
  {
    "key": "RAL-1012",
    "code": "RAL 1012",
    "supplierCode": "1012",
    "label": "RAL 1012 · Zitronengelb",
    "raw": "RAL 1012 (Zitronengelb) - Matt",
    "group": "Gelb",
    "system": "RAL",
    "hex": "#C7B446"
  },
  {
    "key": "RAL-1013",
    "code": "RAL 1013",
    "supplierCode": "1013",
    "label": "RAL 1013 · Perlweiß",
    "raw": "RAL 1013 (Perlweiß) - Matt",
    "group": "Weiß",
    "system": "RAL",
    "hex": "#EAE6CA"
  },
  {
    "key": "RAL-1016",
    "code": "RAL 1016",
    "supplierCode": "1016",
    "label": "RAL 1016 · Schwefelgelb",
    "raw": "RAL 1016 (Schwefelgelb) - Matt",
    "group": "Gelb",
    "system": "RAL",
    "hex": "#EDFF21"
  },
  {
    "key": "RAL-1017",
    "code": "RAL 1017",
    "supplierCode": "1017",
    "label": "RAL 1017 · Safrangelb",
    "raw": "RAL 1017 (Safrangelb) - Matt",
    "group": "Gelb",
    "system": "RAL",
    "hex": "#F5D033"
  },
  {
    "key": "RAL-1018",
    "code": "RAL 1018",
    "supplierCode": "1018",
    "label": "RAL 1018 · Zinkgelb",
    "raw": "RAL 1018 (Zinkgelb) - Matt",
    "group": "Gelb",
    "system": "RAL",
    "hex": "#F8F32B"
  },
  {
    "key": "RAL-1020",
    "code": "RAL 1020",
    "supplierCode": "1020",
    "label": "RAL 1020 · Olivgelb",
    "raw": "RAL 1020 (Olivgelb) - Matt",
    "group": "Gelb",
    "system": "RAL",
    "hex": "#999950"
  },
  {
    "key": "RAL-1021",
    "code": "RAL 1021",
    "supplierCode": "1021",
    "label": "RAL 1021 · Rapsgelb",
    "raw": "RAL 1021 (Rapsgelb) - Matt",
    "group": "Gelb",
    "system": "RAL",
    "hex": "#F3DA0B"
  },
  {
    "key": "RAL-1023",
    "code": "RAL 1023",
    "supplierCode": "1023",
    "label": "RAL 1023 · Verkehrsgelb",
    "raw": "RAL 1023 (Verkehrsgelb) - Matt",
    "group": "Gelb",
    "system": "RAL",
    "hex": "#FAD201"
  },
  {
    "key": "RAL-1024",
    "code": "RAL 1024",
    "supplierCode": "1024",
    "label": "RAL 1024 · Ockergelb",
    "raw": "RAL 1024 (Ockergelb) - Matt",
    "group": "Gelb",
    "system": "RAL",
    "hex": "#AEA04B"
  },
  {
    "key": "RAL-1027",
    "code": "RAL 1027",
    "supplierCode": "1027",
    "label": "RAL 1027 · Currygelb",
    "raw": "RAL 1027 (Currygelb) - Matt",
    "group": "Gelb",
    "system": "RAL",
    "hex": "#9D9101"
  },
  {
    "key": "RAL-1028",
    "code": "RAL 1028",
    "supplierCode": "1028",
    "label": "RAL 1028 · Melonengelb",
    "raw": "RAL 1028 (Melonengelb) - Matt",
    "group": "Gelb",
    "system": "RAL",
    "hex": "#F4A900"
  },
  {
    "key": "RAL-1032",
    "code": "RAL 1032",
    "supplierCode": "1032",
    "label": "RAL 1032 · Ginstergelb",
    "raw": "RAL 1032 (Ginstergelb) - Matt",
    "group": "Gelb",
    "system": "RAL",
    "hex": "#D6AE01"
  },
  {
    "key": "RAL-1033",
    "code": "RAL 1033",
    "supplierCode": "1033",
    "label": "RAL 1033 · Dahliengelb",
    "raw": "RAL 1033 (Dahliengelb) - Matt",
    "group": "Gelb",
    "system": "RAL",
    "hex": "#F3A505"
  },
  {
    "key": "RAL-1034",
    "code": "RAL 1034",
    "supplierCode": "1034",
    "label": "RAL 1034 · Pastellgelb",
    "raw": "RAL 1034 (Pastellgelb) - Matt",
    "group": "Gelb",
    "system": "RAL",
    "hex": "#EFA94A"
  },
  {
    "key": "RAL-1035",
    "code": "RAL 1035",
    "supplierCode": "1035",
    "label": "RAL 1035 · Perlbeige",
    "raw": "RAL 1035 (Perlbeige) - Matt",
    "group": "Beige",
    "system": "RAL",
    "hex": "#6A5D4D"
  },
  {
    "key": "RAL-1036",
    "code": "RAL 1036",
    "supplierCode": "1036",
    "label": "RAL 1036 · Perlgold",
    "raw": "RAL 1036 (Perlgold) - Matt",
    "group": "Gold",
    "system": "RAL",
    "hex": "#705335"
  },
  {
    "key": "RAL-2000",
    "code": "RAL 2000",
    "supplierCode": "2000",
    "label": "RAL 2000 · Gelborange",
    "raw": "RAL 2000 (Gelborange) - Matt",
    "group": "Orange",
    "system": "RAL",
    "hex": "#ED760E"
  },
  {
    "key": "RAL-2001",
    "code": "RAL 2001",
    "supplierCode": "2001",
    "label": "RAL 2001 · Rotorange",
    "raw": "RAL 2001 (Rotorange) - Matt",
    "group": "Orange",
    "system": "RAL",
    "hex": "#C93C20"
  },
  {
    "key": "RAL-2002",
    "code": "RAL 2002",
    "supplierCode": "2002",
    "label": "RAL 2002 · Blutorange",
    "raw": "RAL 2002 (Blutorange) - Matt",
    "group": "Orange",
    "system": "RAL",
    "hex": "#CB2821"
  },
  {
    "key": "RAL-2003",
    "code": "RAL 2003",
    "supplierCode": "2003",
    "label": "RAL 2003 · Pastellorange",
    "raw": "RAL 2003 (Pastellorange) - Matt",
    "group": "Orange",
    "system": "RAL",
    "hex": "#FF7514"
  },
  {
    "key": "RAL-2004",
    "code": "RAL 2004",
    "supplierCode": "2004",
    "label": "RAL 2004 · Reinorange",
    "raw": "RAL 2004 (Reinorange) - Matt",
    "group": "Orange",
    "system": "RAL",
    "hex": "#F44611"
  },
  {
    "key": "RAL-2008",
    "code": "RAL 2008",
    "supplierCode": "2008",
    "label": "RAL 2008 · Hellrotorange",
    "raw": "RAL 2008 (Hellrotorange) - Matt",
    "group": "Orange",
    "system": "RAL",
    "hex": "#F75E25"
  },
  {
    "key": "RAL-2009",
    "code": "RAL 2009",
    "supplierCode": "2009",
    "label": "RAL 2009 · Verkehrsorange",
    "raw": "RAL 2009 (Verkehrsorange) - Matt",
    "group": "Orange",
    "system": "RAL",
    "hex": "#F54021"
  },
  {
    "key": "RAL-2010",
    "code": "RAL 2010",
    "supplierCode": "2010",
    "label": "RAL 2010 · Signalorange",
    "raw": "RAL 2010 (Signalorange) - Matt",
    "group": "Orange",
    "system": "RAL",
    "hex": "#D84B20"
  },
  {
    "key": "RAL-2011",
    "code": "RAL 2011",
    "supplierCode": "2011",
    "label": "RAL 2011 · Tieforange",
    "raw": "RAL 2011 (Tieforange) - Matt",
    "group": "Orange",
    "system": "RAL",
    "hex": "#EC7C26"
  },
  {
    "key": "RAL-2012",
    "code": "RAL 2012",
    "supplierCode": "2012",
    "label": "RAL 2012 · Lachsorange",
    "raw": "RAL 2012 (Lachsorange) - Matt",
    "group": "Orange",
    "system": "RAL",
    "hex": "#E55137"
  },
  {
    "key": "RAL-3000",
    "code": "RAL 3000",
    "supplierCode": "3000",
    "label": "RAL 3000 · Feuerrot",
    "raw": "RAL 3000 (Feuerrot) - Matt",
    "group": "Rot",
    "system": "RAL",
    "hex": "#AF2B1E"
  },
  {
    "key": "RAL-3001",
    "code": "RAL 3001",
    "supplierCode": "3001",
    "label": "RAL 3001 · Signalrot",
    "raw": "RAL 3001 (Signalrot) - Matt",
    "group": "Rot",
    "system": "RAL",
    "hex": "#A52019"
  },
  {
    "key": "RAL-3002",
    "code": "RAL 3002",
    "supplierCode": "3002",
    "label": "RAL 3002 · Karminrot",
    "raw": "RAL 3002 (Karminrot) - Matt",
    "group": "Rot",
    "system": "RAL",
    "hex": "#A2231D"
  },
  {
    "key": "RAL-3003",
    "code": "RAL 3003",
    "supplierCode": "3003",
    "label": "RAL 3003 · Rubinrot",
    "raw": "RAL 3003 (Rubinrot) - Matt",
    "group": "Rot",
    "system": "RAL",
    "hex": "#9B111E"
  },
  {
    "key": "RAL-3004",
    "code": "RAL 3004",
    "supplierCode": "3004",
    "label": "RAL 3004 · Purpurrot",
    "raw": "RAL 3004 (Purpurrot) - Matt",
    "group": "Rot",
    "system": "RAL",
    "hex": "#75151E"
  },
  {
    "key": "RAL-3005",
    "code": "RAL 3005",
    "supplierCode": "3005",
    "label": "RAL 3005 · Weinrot",
    "raw": "RAL 3005 (Weinrot) - Matt",
    "group": "Rot",
    "system": "RAL",
    "hex": "#5E2129"
  },
  {
    "key": "RAL-3009",
    "code": "RAL 3009",
    "supplierCode": "3009",
    "label": "RAL 3009 · Oxidrot",
    "raw": "RAL 3009 (Oxidrot) - Matt",
    "group": "Rot",
    "system": "RAL",
    "hex": "#642424"
  },
  {
    "key": "RAL-3011",
    "code": "RAL 3011",
    "supplierCode": "3011",
    "label": "RAL 3011 · Braunrot",
    "raw": "RAL 3011 (Braunrot) - Matt",
    "group": "Rot",
    "system": "RAL",
    "hex": "#781F19"
  },
  {
    "key": "RAL-3012",
    "code": "RAL 3012",
    "supplierCode": "3012",
    "label": "RAL 3012 · Beigerot",
    "raw": "RAL 3012 (Beigerot) - Matt",
    "group": "Rot",
    "system": "RAL",
    "hex": "#C1876B"
  },
  {
    "key": "RAL-3013",
    "code": "RAL 3013",
    "supplierCode": "3013",
    "label": "RAL 3013 · Tomatenrot",
    "raw": "RAL 3013 (Tomatenrot) - Matt",
    "group": "Rot",
    "system": "RAL",
    "hex": "#A12312"
  },
  {
    "key": "RAL-3014",
    "code": "RAL 3014",
    "supplierCode": "3014",
    "label": "RAL 3014 · Altrosa",
    "raw": "RAL 3014 (Altrosa) - Matt",
    "group": "Rot",
    "system": "RAL",
    "hex": "#D36E70"
  },
  {
    "key": "RAL-3016",
    "code": "RAL 3016",
    "supplierCode": "3016",
    "label": "RAL 3016 · Korallenrot",
    "raw": "RAL 3016 (Korallenrot) - Matt",
    "group": "Rot",
    "system": "RAL",
    "hex": "#B32821"
  },
  {
    "key": "RAL-3017",
    "code": "RAL 3017",
    "supplierCode": "3017",
    "label": "RAL 3017 · Rosé",
    "raw": "RAL 3017 (Rosé) - Matt",
    "group": "Rot",
    "system": "RAL",
    "hex": "#E63244"
  },
  {
    "key": "RAL-3018",
    "code": "RAL 3018",
    "supplierCode": "3018",
    "label": "RAL 3018 · Erdbeerrot",
    "raw": "RAL 3018 (Erdbeerrot) - Matt",
    "group": "Rot",
    "system": "RAL",
    "hex": "#D53032"
  },
  {
    "key": "RAL-3020",
    "code": "RAL 3020",
    "supplierCode": "3020",
    "label": "RAL 3020 · Verkehrsrot",
    "raw": "RAL 3020 (Verkehrsrot) - Matt",
    "group": "Rot",
    "system": "RAL",
    "hex": "#CC0605"
  },
  {
    "key": "RAL-3022",
    "code": "RAL 3022",
    "supplierCode": "3022",
    "label": "RAL 3022 · Lachsrot",
    "raw": "RAL 3022 (Lachsrot) - Matt",
    "group": "Rot",
    "system": "RAL",
    "hex": "#D95030"
  },
  {
    "key": "RAL-3031",
    "code": "RAL 3031",
    "supplierCode": "3031",
    "label": "RAL 3031 · Orientrot",
    "raw": "RAL 3031 (Orientrot) - Matt",
    "group": "Rot",
    "system": "RAL",
    "hex": "#B32428"
  },
  {
    "key": "RAL-4001",
    "code": "RAL 4001",
    "supplierCode": "4001",
    "label": "RAL 4001 · Rotlila",
    "raw": "RAL 4001 (Rotlila) - Matt",
    "group": "Violett",
    "system": "RAL",
    "hex": "#6D3F5B"
  },
  {
    "key": "RAL-4002",
    "code": "RAL 4002",
    "supplierCode": "4002",
    "label": "RAL 4002 · Rotviolett",
    "raw": "RAL 4002 (Rotviolett) - Matt",
    "group": "Violett",
    "system": "RAL",
    "hex": "#922B3E"
  },
  {
    "key": "RAL-4003",
    "code": "RAL 4003",
    "supplierCode": "4003",
    "label": "RAL 4003 · Erikaviolett",
    "raw": "RAL 4003 (Erikaviolett) - Matt",
    "group": "Violett",
    "system": "RAL",
    "hex": "#DE4C8A"
  },
  {
    "key": "RAL-4005",
    "code": "RAL 4005",
    "supplierCode": "4005",
    "label": "RAL 4005 · Blaulila",
    "raw": "RAL 4005 (Blaulila) - Matt",
    "group": "Violett",
    "system": "RAL",
    "hex": "#6C4675"
  },
  {
    "key": "RAL-4006",
    "code": "RAL 4006",
    "supplierCode": "4006",
    "label": "RAL 4006 · Verkehrspurpur",
    "raw": "RAL 4006 (Verkehrspurpur) - Matt",
    "group": "Violett",
    "system": "RAL",
    "hex": "#A03472"
  },
  {
    "key": "RAL-4007",
    "code": "RAL 4007",
    "supplierCode": "4007",
    "label": "RAL 4007 · Purpurviolett",
    "raw": "RAL 4007 (Purpurviolett) - Matt",
    "group": "Violett",
    "system": "RAL",
    "hex": "#4A192C"
  },
  {
    "key": "RAL-4008",
    "code": "RAL 4008",
    "supplierCode": "4008",
    "label": "RAL 4008 · Signalviolett",
    "raw": "RAL 4008 (Signalviolett) - Matt",
    "group": "Violett",
    "system": "RAL",
    "hex": "#924E7D"
  },
  {
    "key": "RAL-4009",
    "code": "RAL 4009",
    "supplierCode": "4009",
    "label": "RAL 4009 · Pastellviolett",
    "raw": "RAL 4009 (Pastellviolett) - Matt",
    "group": "Violett",
    "system": "RAL",
    "hex": "#A18594"
  },
  {
    "key": "RAL-4010",
    "code": "RAL 4010",
    "supplierCode": "4010",
    "label": "RAL 4010 · Telemagenta",
    "raw": "RAL 4010 (Telemagenta) - Matt",
    "group": "Violett",
    "system": "RAL",
    "hex": "#CF3476"
  },
  {
    "key": "RAL-5001",
    "code": "RAL 5001",
    "supplierCode": "5001",
    "label": "RAL 5001 · Grünblau",
    "raw": "RAL 5001 (Grünblau) - Matt",
    "group": "Blau",
    "system": "RAL",
    "hex": "#1F3438"
  },
  {
    "key": "RAL-5003",
    "code": "RAL 5003",
    "supplierCode": "5003",
    "label": "RAL 5003 · Saphirblau",
    "raw": "RAL 5003 (Saphirblau) - Matt",
    "group": "Blau",
    "system": "RAL",
    "hex": "#1D1E33"
  },
  {
    "key": "RAL-5004",
    "code": "RAL 5004",
    "supplierCode": "5004",
    "label": "RAL 5004 · Schwarzblau",
    "raw": "RAL 5004 (Schwarzblau) - Matt",
    "group": "Blau",
    "system": "RAL",
    "hex": "#18171C"
  },
  {
    "key": "RAL-5005",
    "code": "RAL 5005",
    "supplierCode": "5005",
    "label": "RAL 5005 · Signalblau",
    "raw": "RAL 5005 (Signalblau) - Matt",
    "group": "Blau",
    "system": "RAL",
    "hex": "#1E2460"
  },
  {
    "key": "RAL-5007",
    "code": "RAL 5007",
    "supplierCode": "5007",
    "label": "RAL 5007 · Brillantblau",
    "raw": "RAL 5007 (Brillantblau) - Matt",
    "group": "Blau",
    "system": "RAL",
    "hex": "#3E5F8A"
  },
  {
    "key": "RAL-5008",
    "code": "RAL 5008",
    "supplierCode": "5008",
    "label": "RAL 5008 · Graublau",
    "raw": "RAL 5008 (Graublau) - Matt",
    "group": "Blau",
    "system": "RAL",
    "hex": "#26252D"
  },
  {
    "key": "RAL-5009",
    "code": "RAL 5009",
    "supplierCode": "5009",
    "label": "RAL 5009 · Azurblau",
    "raw": "RAL 5009 (Azurblau) - Matt",
    "group": "Blau",
    "system": "RAL",
    "hex": "#025669"
  },
  {
    "key": "RAL-5010",
    "code": "RAL 5010",
    "supplierCode": "5010",
    "label": "RAL 5010 · Enzianblau",
    "raw": "RAL 5010 (Enzianblau) - Matt",
    "group": "Blau",
    "system": "RAL",
    "hex": "#0E294B"
  },
  {
    "key": "RAL-5011",
    "code": "RAL 5011",
    "supplierCode": "5011",
    "label": "RAL 5011 · Stahlblau",
    "raw": "RAL 5011 (Stahlblau) - Matt",
    "group": "Blau",
    "system": "RAL",
    "hex": "#231A24"
  },
  {
    "key": "RAL-5012",
    "code": "RAL 5012",
    "supplierCode": "5012",
    "label": "RAL 5012 · Lichtblau",
    "raw": "RAL 5012 (Lichtblau) - Matt",
    "group": "Blau",
    "system": "RAL",
    "hex": "#3B83BD"
  },
  {
    "key": "RAL-5013",
    "code": "RAL 5013",
    "supplierCode": "5013",
    "label": "RAL 5013 · Kobaltblau",
    "raw": "RAL 5013 (Kobaltblau) - Matt",
    "group": "Blau",
    "system": "RAL",
    "hex": "#1E213D"
  },
  {
    "key": "RAL-5014",
    "code": "RAL 5014",
    "supplierCode": "5014",
    "label": "RAL 5014 · Taubenblau",
    "raw": "RAL 5014 (Taubenblau) - Matt",
    "group": "Blau",
    "system": "RAL",
    "hex": "#606E8C"
  },
  {
    "key": "RAL-5015",
    "code": "RAL 5015",
    "supplierCode": "5015",
    "label": "RAL 5015 · Himmelblau",
    "raw": "RAL 5015 (Himmelblau) - Matt",
    "group": "Blau",
    "system": "RAL",
    "hex": "#2271B3"
  },
  {
    "key": "RAL-5017",
    "code": "RAL 5017",
    "supplierCode": "5017",
    "label": "RAL 5017 · Verkehrsblau",
    "raw": "RAL 5017 (Verkehrsblau) - Matt",
    "group": "Blau",
    "system": "RAL",
    "hex": "#063971"
  },
  {
    "key": "RAL-5018",
    "code": "RAL 5018",
    "supplierCode": "5018",
    "label": "RAL 5018 · Türkisblau",
    "raw": "RAL 5018 (Türkisblau) - Matt",
    "group": "Blau",
    "system": "RAL",
    "hex": "#3F888F"
  },
  {
    "key": "RAL-5019",
    "code": "RAL 5019",
    "supplierCode": "5019",
    "label": "RAL 5019 · Capriblau",
    "raw": "RAL 5019 (Capriblau) - Matt",
    "group": "Blau",
    "system": "RAL",
    "hex": "#1B5583"
  },
  {
    "key": "RAL-5020",
    "code": "RAL 5020",
    "supplierCode": "5020",
    "label": "RAL 5020 · Ozeanblau",
    "raw": "RAL 5020 (Ozeanblau) - Matt",
    "group": "Blau",
    "system": "RAL",
    "hex": "#1D334A"
  },
  {
    "key": "RAL-5021",
    "code": "RAL 5021",
    "supplierCode": "5021",
    "label": "RAL 5021 · Wasserblau",
    "raw": "RAL 5021 (Wasserblau) - Matt",
    "group": "Blau",
    "system": "RAL",
    "hex": "#256D7B"
  },
  {
    "key": "RAL-5022",
    "code": "RAL 5022",
    "supplierCode": "5022",
    "label": "RAL 5022 · Nachtblau",
    "raw": "RAL 5022 (Nachtblau) - Matt",
    "group": "Blau",
    "system": "RAL",
    "hex": "#252850"
  },
  {
    "key": "RAL-5023",
    "code": "RAL 5023",
    "supplierCode": "5023",
    "label": "RAL 5023 · Fernblau",
    "raw": "RAL 5023 (Fernblau) - Matt",
    "group": "Blau",
    "system": "RAL",
    "hex": "#49678D"
  },
  {
    "key": "RAL-5024",
    "code": "RAL 5024",
    "supplierCode": "5024",
    "label": "RAL 5024 · Pastellblau",
    "raw": "RAL 5024 (Pastellblau) - Matt",
    "group": "Blau",
    "system": "RAL",
    "hex": "#5D9B9B"
  },
  {
    "key": "RAL-6001",
    "code": "RAL 6001",
    "supplierCode": "6001",
    "label": "RAL 6001 · Smaragdgrün",
    "raw": "RAL 6001 (Smaragdgrün) - Matt",
    "group": "Grün",
    "system": "RAL",
    "hex": "#287233"
  },
  {
    "key": "RAL-6002",
    "code": "RAL 6002",
    "supplierCode": "6002",
    "label": "RAL 6002 · Laubgrün",
    "raw": "RAL 6002 (Laubgrün) - Matt",
    "group": "Grün",
    "system": "RAL",
    "hex": "#2D572C"
  },
  {
    "key": "RAL-6003",
    "code": "RAL 6003",
    "supplierCode": "6003",
    "label": "RAL 6003 · Olivgrün",
    "raw": "RAL 6003 (Olivgrün) - Matt",
    "group": "Grün",
    "system": "RAL",
    "hex": "#424632"
  },
  {
    "key": "RAL-6005",
    "code": "RAL 6005",
    "supplierCode": "6005",
    "label": "RAL 6005 · Moosgrün",
    "raw": "RAL 6005 (Moosgrün) - Matt",
    "group": "Grün",
    "system": "RAL",
    "hex": "#2F4538"
  },
  {
    "key": "RAL-6006",
    "code": "RAL 6006",
    "supplierCode": "6006",
    "label": "RAL 6006 · Grauoliv",
    "raw": "RAL 6006 (Grauoliv) - Matt",
    "group": "Grün",
    "system": "RAL",
    "hex": "#3E3B32"
  },
  {
    "key": "RAL-6007",
    "code": "RAL 6007",
    "supplierCode": "6007",
    "label": "RAL 6007 · Flaschengrün",
    "raw": "RAL 6007 (Flaschengrün) - Matt",
    "group": "Grün",
    "system": "RAL",
    "hex": "#343B29"
  },
  {
    "key": "RAL-6008",
    "code": "RAL 6008",
    "supplierCode": "6008",
    "label": "RAL 6008 · Braungrün",
    "raw": "RAL 6008 (Braungrün) - Matt",
    "group": "Grün",
    "system": "RAL",
    "hex": "#39352A"
  },
  {
    "key": "RAL-6009",
    "code": "RAL 6009",
    "supplierCode": "6009",
    "label": "RAL 6009 · Tannengrün",
    "raw": "RAL 6009 (Tannengrün) - Matt",
    "group": "Grün",
    "system": "RAL",
    "hex": "#31372B"
  },
  {
    "key": "RAL-6010",
    "code": "RAL 6010",
    "supplierCode": "6010",
    "label": "RAL 6010 · Grasgrün",
    "raw": "RAL 6010 (Grasgrün) - Matt",
    "group": "Grün",
    "system": "RAL",
    "hex": "#35682D"
  },
  {
    "key": "RAL-6011",
    "code": "RAL 6011",
    "supplierCode": "6011",
    "label": "RAL 6011 · Resedagrün",
    "raw": "RAL 6011 (Resedagrün) - Matt",
    "group": "Grün",
    "system": "RAL",
    "hex": "#587246"
  },
  {
    "key": "RAL-6012",
    "code": "RAL 6012",
    "supplierCode": "6012",
    "label": "RAL 6012 · Schwarzgrün",
    "raw": "RAL 6012 (Schwarzgrün) - Matt",
    "group": "Grün",
    "system": "RAL",
    "hex": "#343E40"
  },
  {
    "key": "RAL-6014",
    "code": "RAL 6014",
    "supplierCode": "6014",
    "label": "RAL 6014 · Gelboliv",
    "raw": "RAL 6014 (Gelboliv) - Matt",
    "group": "Grün",
    "system": "RAL",
    "hex": "#47402E"
  },
  {
    "key": "RAL-6015",
    "code": "RAL 6015",
    "supplierCode": "6015",
    "label": "RAL 6015 · Schwarzoliv",
    "raw": "RAL 6015 (Schwarzoliv) - Matt",
    "group": "Grün",
    "system": "RAL",
    "hex": "#3B3C36"
  },
  {
    "key": "RAL-6016",
    "code": "RAL 6016",
    "supplierCode": "6016",
    "label": "RAL 6016 · Türkisgrün",
    "raw": "RAL 6016 (Türkisgrün) - Matt",
    "group": "Grün",
    "system": "RAL",
    "hex": "#1E5945"
  },
  {
    "key": "RAL-6017",
    "code": "RAL 6017",
    "supplierCode": "6017",
    "label": "RAL 6017 · Maigrün",
    "raw": "RAL 6017 (Maigrün) - Matt",
    "group": "Grün",
    "system": "RAL",
    "hex": "#4C9141"
  },
  {
    "key": "RAL-6019",
    "code": "RAL 6019",
    "supplierCode": "6019",
    "label": "RAL 6019 · Weißgrün",
    "raw": "RAL 6019 (Weißgrün) - Matt",
    "group": "Grün",
    "system": "RAL",
    "hex": "#BDECB6"
  },
  {
    "key": "RAL-6020",
    "code": "RAL 6020",
    "supplierCode": "6020",
    "label": "RAL 6020 · Chromoxidgrün",
    "raw": "RAL 6020 (Chromoxidgrün) - Matt",
    "group": "Grün",
    "system": "RAL",
    "hex": "#2E3A23"
  },
  {
    "key": "RAL-6022",
    "code": "RAL 6022",
    "supplierCode": "6022",
    "label": "RAL 6022 · Braunoliv",
    "raw": "RAL 6022 (Braunoliv) - Matt",
    "group": "Grün",
    "system": "RAL",
    "hex": "#25221B"
  },
  {
    "key": "RAL-6024",
    "code": "RAL 6024",
    "supplierCode": "6024",
    "label": "RAL 6024 · Verkehrsgrün",
    "raw": "RAL 6024 (Verkehrsgrün) - Matt",
    "group": "Grün",
    "system": "RAL",
    "hex": "#308446"
  },
  {
    "key": "RAL-6025",
    "code": "RAL 6025",
    "supplierCode": "6025",
    "label": "RAL 6025 · Farngrün",
    "raw": "RAL 6025 (Farngrün) - Matt",
    "group": "Grün",
    "system": "RAL",
    "hex": "#3D642D"
  },
  {
    "key": "RAL-6026",
    "code": "RAL 6026",
    "supplierCode": "6026",
    "label": "RAL 6026 · Opalgrün",
    "raw": "RAL 6026 (Opalgrün) - Matt",
    "group": "Grün",
    "system": "RAL",
    "hex": "#015D52"
  },
  {
    "key": "RAL-6027",
    "code": "RAL 6027",
    "supplierCode": "6027",
    "label": "RAL 6027 · Lichtgrün",
    "raw": "RAL 6027 (Lichtgrün) - Matt",
    "group": "Grün",
    "system": "RAL",
    "hex": "#84C3BE"
  },
  {
    "key": "RAL-6028",
    "code": "RAL 6028",
    "supplierCode": "6028",
    "label": "RAL 6028 · Kieferngrün",
    "raw": "RAL 6028 (Kieferngrün) - Matt",
    "group": "Grün",
    "system": "RAL",
    "hex": "#2C5545"
  },
  {
    "key": "RAL-6029",
    "code": "RAL 6029",
    "supplierCode": "6029",
    "label": "RAL 6029 · Minzgrün",
    "raw": "RAL 6029 (Minzgrün) - Matt",
    "group": "Grün",
    "system": "RAL",
    "hex": "#20603D"
  },
  {
    "key": "RAL-6032",
    "code": "RAL 6032",
    "supplierCode": "6032",
    "label": "RAL 6032 · Signalgrün",
    "raw": "RAL 6032 (Signalgrün) - Matt",
    "group": "Grün",
    "system": "RAL",
    "hex": "#317F43"
  },
  {
    "key": "RAL-6033",
    "code": "RAL 6033",
    "supplierCode": "6033",
    "label": "RAL 6033 · Minttürkis",
    "raw": "RAL 6033 (Minttürkis) - Matt",
    "group": "Grün",
    "system": "RAL",
    "hex": "#497E76"
  },
  {
    "key": "RAL-6034",
    "code": "RAL 6034",
    "supplierCode": "6034",
    "label": "RAL 6034 · Pastelltürkis",
    "raw": "RAL 6034 (Pastelltürkis) - Matt",
    "group": "Grün",
    "system": "RAL",
    "hex": "#7FB5B5"
  },
  {
    "key": "RAL-7000",
    "code": "RAL 7000",
    "supplierCode": "7000",
    "label": "RAL 7000 · Fehgrau",
    "raw": "RAL 7000 (Fehgrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#78858B"
  },
  {
    "key": "RAL-7001",
    "code": "RAL 7001",
    "supplierCode": "7001",
    "label": "RAL 7001 · Silbergrau",
    "raw": "RAL 7001 (Silbergrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#8A9597"
  },
  {
    "key": "RAL-7002",
    "code": "RAL 7002",
    "supplierCode": "7002",
    "label": "RAL 7002 · Olivgrau",
    "raw": "RAL 7002 (Olivgrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#7E7B52"
  },
  {
    "key": "RAL-7003",
    "code": "RAL 7003",
    "supplierCode": "7003",
    "label": "RAL 7003 · Moosgrau",
    "raw": "RAL 7003 (Moosgrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#6C7059"
  },
  {
    "key": "RAL-7004",
    "code": "RAL 7004",
    "supplierCode": "7004",
    "label": "RAL 7004 · Signalgrau",
    "raw": "RAL 7004 (Signalgrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#969992"
  },
  {
    "key": "RAL-7005",
    "code": "RAL 7005",
    "supplierCode": "7005",
    "label": "RAL 7005 · Mausgrau",
    "raw": "RAL 7005 (Mausgrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#646B63"
  },
  {
    "key": "RAL-7008",
    "code": "RAL 7008",
    "supplierCode": "7008",
    "label": "RAL 7008 · Khakigrau",
    "raw": "RAL 7008 (Khakigrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#6A5F31"
  },
  {
    "key": "RAL-7009",
    "code": "RAL 7009",
    "supplierCode": "7009",
    "label": "RAL 7009 · Grüngrau",
    "raw": "RAL 7009 (Grüngrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#4D5645"
  },
  {
    "key": "RAL-7010",
    "code": "RAL 7010",
    "supplierCode": "7010",
    "label": "RAL 7010 · Zeltgrau",
    "raw": "RAL 7010 (Zeltgrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#4C514A"
  },
  {
    "key": "RAL-7011",
    "code": "RAL 7011",
    "supplierCode": "7011",
    "label": "RAL 7011 · Eisengrau",
    "raw": "RAL 7011 (Eisengrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#434B4D"
  },
  {
    "key": "RAL-7012",
    "code": "RAL 7012",
    "supplierCode": "7012",
    "label": "RAL 7012 · Basaltgrau",
    "raw": "RAL 7012 (Basaltgrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#4E5754"
  },
  {
    "key": "RAL-7013",
    "code": "RAL 7013",
    "supplierCode": "7013",
    "label": "RAL 7013 · Braungrau",
    "raw": "RAL 7013 (Braungrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#464531"
  },
  {
    "key": "RAL-7015",
    "code": "RAL 7015",
    "supplierCode": "7015",
    "label": "RAL 7015 · Schiefergrau",
    "raw": "RAL 7015 (Schiefergrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#434750"
  },
  {
    "key": "RAL-7023",
    "code": "RAL 7023",
    "supplierCode": "7023",
    "label": "RAL 7023 · Betongrau",
    "raw": "RAL 7023 (Betongrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#686C5E"
  },
  {
    "key": "RAL-7024",
    "code": "RAL 7024",
    "supplierCode": "7024",
    "label": "RAL 7024 · Graphitgrau",
    "raw": "RAL 7024 (Graphitgrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#474A51"
  },
  {
    "key": "RAL-7026",
    "code": "RAL 7026",
    "supplierCode": "7026",
    "label": "RAL 7026 · Granitgrau",
    "raw": "RAL 7026 (Granitgrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#2F353B"
  },
  {
    "key": "RAL-7032",
    "code": "RAL 7032",
    "supplierCode": "7032",
    "label": "RAL 7032 · Kieselgrau",
    "raw": "RAL 7032 (Kieselgrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#B8B799"
  },
  {
    "key": "RAL-7033",
    "code": "RAL 7033",
    "supplierCode": "7033",
    "label": "RAL 7033 · Zementgrau",
    "raw": "RAL 7033 (Zementgrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#7D8471"
  },
  {
    "key": "RAL-7034",
    "code": "RAL 7034",
    "supplierCode": "7034",
    "label": "RAL 7034 · Gelbgrau",
    "raw": "RAL 7034 (Gelbgrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#8F8B66"
  },
  {
    "key": "RAL-7036",
    "code": "RAL 7036",
    "supplierCode": "7036",
    "label": "RAL 7036 · Platingrau",
    "raw": "RAL 7036 (Platingrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#7F7679"
  },
  {
    "key": "RAL-7037",
    "code": "RAL 7037",
    "supplierCode": "7037",
    "label": "RAL 7037 · Staubgrau",
    "raw": "RAL 7037 (Staubgrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#7D7F7D"
  },
  {
    "key": "RAL-7038",
    "code": "RAL 7038",
    "supplierCode": "7038",
    "label": "RAL 7038 · Achatgrau",
    "raw": "RAL 7038 (Achatgrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#B5B8B1"
  },
  {
    "key": "RAL-7040",
    "code": "RAL 7040",
    "supplierCode": "7040",
    "label": "RAL 7040 · Fenstergrau",
    "raw": "RAL 7040 (Fenstergrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#9DA1AA"
  },
  {
    "key": "RAL-7042",
    "code": "RAL 7042",
    "supplierCode": "7042",
    "label": "RAL 7042 · Verkehrsgrau A",
    "raw": "RAL 7042 (Verkehrsgrau A) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#8D948D"
  },
  {
    "key": "RAL-7043",
    "code": "RAL 7043",
    "supplierCode": "7043",
    "label": "RAL 7043 · Verkehrsgrau B",
    "raw": "RAL 7043 (Verkehrsgrau B) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#4E5452"
  },
  {
    "key": "RAL-7045",
    "code": "RAL 7045",
    "supplierCode": "7045",
    "label": "RAL 7045 · Telegrau 1",
    "raw": "RAL 7045 (Telegrau 1) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#909090"
  },
  {
    "key": "RAL-7046",
    "code": "RAL 7046",
    "supplierCode": "7046",
    "label": "RAL 7046 · Telegrau 2",
    "raw": "RAL 7046 (Telegrau 2) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#82898F"
  },
  {
    "key": "RAL-7047",
    "code": "RAL 7047",
    "supplierCode": "7047",
    "label": "RAL 7047 · Telegrau 4",
    "raw": "RAL 7047 (Telegrau 4) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#D0D0D0"
  },
  {
    "key": "RAL-8000",
    "code": "RAL 8000",
    "supplierCode": "8000",
    "label": "RAL 8000 · Grünbraun",
    "raw": "RAL 8000 (Grünbraun) - Matt",
    "group": "Braun",
    "system": "RAL",
    "hex": "#826C34"
  },
  {
    "key": "RAL-8001",
    "code": "RAL 8001",
    "supplierCode": "8001",
    "label": "RAL 8001 · Ockerbraun",
    "raw": "RAL 8001 (Ockerbraun) - Matt",
    "group": "Braun",
    "system": "RAL",
    "hex": "#955F20"
  },
  {
    "key": "RAL-8002",
    "code": "RAL 8002",
    "supplierCode": "8002",
    "label": "RAL 8002 · Signalbraun",
    "raw": "RAL 8002 (Signalbraun) - Matt",
    "group": "Braun",
    "system": "RAL",
    "hex": "#6C3B2A"
  },
  {
    "key": "RAL-8003",
    "code": "RAL 8003",
    "supplierCode": "8003",
    "label": "RAL 8003 · Lehmbraun",
    "raw": "RAL 8003 (Lehmbraun) - Matt",
    "group": "Braun",
    "system": "RAL",
    "hex": "#734222"
  },
  {
    "key": "RAL-8007",
    "code": "RAL 8007",
    "supplierCode": "8007",
    "label": "RAL 8007 · Rehbraun",
    "raw": "RAL 8007 (Rehbraun) - Matt",
    "group": "Braun",
    "system": "RAL",
    "hex": "#59351F"
  },
  {
    "key": "RAL-8008",
    "code": "RAL 8008",
    "supplierCode": "8008",
    "label": "RAL 8008 · Olivbraun",
    "raw": "RAL 8008 (Olivbraun) - Matt",
    "group": "Braun",
    "system": "RAL",
    "hex": "#6F4F28"
  },
  {
    "key": "RAL-8011",
    "code": "RAL 8011",
    "supplierCode": "8011",
    "label": "RAL 8011 · Nussbraun",
    "raw": "RAL 8011 (Nussbraun) - Matt",
    "group": "Braun",
    "system": "RAL",
    "hex": "#5B3A29"
  },
  {
    "key": "RAL-8012",
    "code": "RAL 8012",
    "supplierCode": "8012",
    "label": "RAL 8012 · Rotbraun",
    "raw": "RAL 8012 (Rotbraun) - Matt",
    "group": "Braun",
    "system": "RAL",
    "hex": "#592321"
  },
  {
    "key": "RAL-8014",
    "code": "RAL 8014",
    "supplierCode": "8014",
    "label": "RAL 8014 · Sepiabraun",
    "raw": "RAL 8014 (Sepiabraun) - Matt",
    "group": "Braun",
    "system": "RAL",
    "hex": "#4A3526"
  },
  {
    "key": "RAL-8015",
    "code": "RAL 8015",
    "supplierCode": "8015",
    "label": "RAL 8015 · Kastanienbraun",
    "raw": "RAL 8015 (Kastanienbraun) - Matt",
    "group": "Braun",
    "system": "RAL",
    "hex": "#633A34"
  },
  {
    "key": "RAL-8016",
    "code": "RAL 8016",
    "supplierCode": "8016",
    "label": "RAL 8016 · Mahagonibraun",
    "raw": "RAL 8016 (Mahagonibraun) - Matt",
    "group": "Braun",
    "system": "RAL",
    "hex": "#4C2F27"
  },
  {
    "key": "RAL-8017",
    "code": "RAL 8017",
    "supplierCode": "8017",
    "label": "RAL 8017 · Schokoladenbraun",
    "raw": "RAL 8017 (Schokoladenbraun) - Matt",
    "group": "Braun",
    "system": "RAL",
    "hex": "#45322E"
  },
  {
    "key": "RAL-8023",
    "code": "RAL 8023",
    "supplierCode": "8023",
    "label": "RAL 8023 · Orangebraun",
    "raw": "RAL 8023 (Orangebraun) - Matt",
    "group": "Braun",
    "system": "RAL",
    "hex": "#A65E2E"
  },
  {
    "key": "RAL-8025",
    "code": "RAL 8025",
    "supplierCode": "8025",
    "label": "RAL 8025 · Blassbraun",
    "raw": "RAL 8025 (Blassbraun) - Matt",
    "group": "Braun",
    "system": "RAL",
    "hex": "#755C48"
  },
  {
    "key": "RAL-8028",
    "code": "RAL 8028",
    "supplierCode": "8028",
    "label": "RAL 8028 · Terrabraun",
    "raw": "RAL 8028 (Terrabraun) - Matt",
    "group": "Braun",
    "system": "RAL",
    "hex": "#4E3B31"
  },
  {
    "key": "RAL-8029",
    "code": "RAL 8029",
    "supplierCode": "8029",
    "label": "RAL 8029 · Perlkupfer",
    "raw": "RAL 8029 (Perlkupfer) - Matt",
    "group": "Braun",
    "system": "RAL",
    "hex": "#763C28"
  },
  {
    "key": "RAL-9003",
    "code": "RAL 9003",
    "supplierCode": "9003",
    "label": "RAL 9003 · Signalweiß",
    "raw": "RAL 9003 (Signalweiß) - Matt",
    "group": "Weiß",
    "system": "RAL",
    "hex": "#F4F4F4"
  },
  {
    "key": "RAL-9004",
    "code": "RAL 9004",
    "supplierCode": "9004",
    "label": "RAL 9004 · Signalschwarz",
    "raw": "RAL 9004 (Signalschwarz) - Matt",
    "group": "Schwarz",
    "system": "RAL",
    "hex": "#282828"
  },
  {
    "key": "RAL-9006",
    "code": "RAL 9006",
    "supplierCode": "9006",
    "label": "RAL 9006 · Weißaluminium",
    "raw": "RAL 9006 (Weißaluminium) - Matt",
    "group": "Silber",
    "system": "RAL",
    "hex": "#A5A5A5"
  },
  {
    "key": "RAL-9007",
    "code": "RAL 9007",
    "supplierCode": "9007",
    "label": "RAL 9007 · Graualuminium",
    "raw": "RAL 9007 (Graualuminium) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#8F8F8F"
  },
  {
    "key": "RAL-9010",
    "code": "RAL 9010",
    "supplierCode": "9010",
    "label": "RAL 9010 · Reinweiß",
    "raw": "RAL 9010 (Reinweiß) - Matt",
    "group": "Weiß",
    "system": "RAL",
    "hex": "#FFFFFF"
  },
  {
    "key": "RAL-9011",
    "code": "RAL 9011",
    "supplierCode": "9011",
    "label": "RAL 9011 · Graphitschwarz",
    "raw": "RAL 9011 (Graphitschwarz) - Matt",
    "group": "Schwarz",
    "system": "RAL",
    "hex": "#1C1C1C"
  },
  {
    "key": "RAL-9017",
    "code": "RAL 9017",
    "supplierCode": "9017",
    "label": "RAL 9017 · Verkehrsschwarz",
    "raw": "RAL 9017 (Verkehrsschwarz) - Matt",
    "group": "Schwarz",
    "system": "RAL",
    "hex": "#1E1E1E"
  },
  {
    "key": "RAL-9018",
    "code": "RAL 9018",
    "supplierCode": "9018",
    "label": "RAL 9018 · Papyrusweiß",
    "raw": "RAL 9018 (Papyrusweiß) - Matt",
    "group": "Weiß",
    "system": "RAL",
    "hex": "#D7D7D7"
  },
  {
    "key": "RAL-9023",
    "code": "RAL 9023",
    "supplierCode": "9023",
    "label": "RAL 9023 · Perldunkelgrau",
    "raw": "RAL 9023 (Perldunkelgrau) - Matt",
    "group": "Grau",
    "system": "RAL",
    "hex": "#828282"
  },
  {
    "key": "AXALTA-C32",
    "code": "AXALTA C32",
    "supplierCode": "2011164121",
    "label": "SuprAnodic Light Bronze C32",
    "raw": "SuprAnodic AXALTA Light Bronze C32 (SD201C1164121 metallic) - Matt",
    "group": "Braun",
    "system": "AXALTA",
    "hex": "#BBAD86"
  },
  {
    "key": "AXALTA-C33",
    "code": "AXALTA C33",
    "supplierCode": "2018210521",
    "label": "SuprAnodic Medium Bronze C33",
    "raw": "SuprAnodic AXALTA Medium Bronze C33 (SD201C8210521 metallic) - Matt",
    "group": "Braun",
    "system": "AXALTA",
    "hex": "#92703F"
  },
  {
    "key": "AXALTA-C34",
    "code": "AXALTA C34",
    "supplierCode": "2018210621",
    "label": "SuprAnodic Dark Bronze C34",
    "raw": "SuprAnodic AXALTA Dark Bronze C34 (SD201C8210621 metallic) - Matt",
    "group": "Braun",
    "system": "AXALTA",
    "hex": "#4F2A12"
  }
];
  const normalize = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/ß/g, 'ss').replace(/ral\s*(\d{4})/g, 'ral $1').replace(/db\s*(70[123])/g, 'db $1').replace(/[^a-z0-9]+/g, ' ').trim();
  const aliases = new Map();
  colors.forEach(color => [color.raw, color.label, color.code, color.key].forEach(label => aliases.set(normalize(label), color)));
  const find = value => aliases.get(normalize(value)) || null;
  const search = (items, query) => { const terms = normalize(query).split(' ').filter(Boolean); return items.filter(item => { const color = find(item.value) || {}; const text = normalize([item.value,color.label,color.code,color.system].join(' ')); return terms.every(term => text.includes(term)); }); };
  const api = { colors, find, search, normalize };
  root.OeCarrezColors = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window === 'undefined' ? globalThis : window);
